import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useIsPWAInstalled } from "../../hooks/useIsPWAInstalled";
import LangSwitcher from "../LangSwitcher";
import ModalConfirmation from "../ModalConfirmation/ModalConfirmation";

import { useUserStore } from "../../store/userStore";

import { ReactComponent as UserIcon } from "../../static/images/user_profile.svg";
import { ReactComponent as DownloadIcon } from "../../static/images/donwload.svg";
import { ReactComponent as CellsIcon } from "../../static/images/cells.svg";
import { ReactComponent as CalendarIcon } from "../../static/images/calendar.svg";
import { ReactComponent as ClockIcon } from "../../static/images/sand_clock.svg";
import { ReactComponent as GroupIcon } from "../../static/images/group.svg";
import { ReactComponent as FinanceIcon } from "../../static/images/finance.svg";
import { ReactComponent as Setting } from "../../static/images/setting.svg";
import { ReactComponent as Customers } from "../../static/images/customers_nav_icon.svg";
import { ReactComponent as Invitation } from "../../static/images/invitation.svg";
import { ReactComponent as RequestIcon } from "../../static/images/requests.svg";
import { ReactComponent as Share } from "../../static/images/share.svg";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

import "./style.scss";

const SandwichNavigation = ({ active, sandwichToggle }) => {
  const [confirmModalToggle, setConfirmModalToggle] = useState("");

  const [copied, setCopied] = useState("");

  const navigate = useNavigate();
  const isPWA = useIsPWAInstalled();

  const { t } = useTranslation();
  const { user, fetchUser, clearUser } = useUserStore();

  const handleDownloadClick = () => {
    localStorage.removeItem("ps10003000");
    window.dispatchEvent(new Event("localStorageChangedPwa"));
    sandwichToggle();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(user?.profileDetailsUrl);
      setCopied({
        text: t("copied!"),
        success: "success",
      });
      setTimeout(() => setCopied(""), 1000);
    } catch (err) {
      setCopied({
        text: t("failed_copy!"),
        success: "failed",
      });

      console.error("Failed to copy: ", err);
      setTimeout(() => setCopied(""), 1000);
    }
  };

  const formattedPricePlans = {
    Starter: "basic",
    Advanced: "standard",
    Pro: "pro",
    ProForFree: "pro",
  };

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <div className={`sandwich-container ${active}`}>
      <ModalConfirmation
        modalText={t("logout_confirm")}
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        cancelButtonText={t("no")}
        confirmButtonText={t("yes")}
        confirm={() => {
          localStorage.removeItem("ps10005000");
          localStorage.removeItem("ps10004000");
          sandwichToggle();
          setConfirmModalToggle("");
          navigate("/");
          clearUser();
        }}
      />

      <div className="sandwich-content">
        <div
          className="username-container"
          style={{
            marginBottom: user?.type === "Consumer" ? "40px" : "8px",
          }}
        >
          <div
            className="username"
            onClick={() => {
              sandwichToggle();
              navigate("/profile");
            }}
          >
            {user?.profileUrl ? (
              <img src={user?.profileUrl} alt="profilePic" />
            ) : (
              <UserIcon />
            )}
            <span>{user?.name}</span>
          </div>
          {user?.type === "Provider" ? (
            <div
              className={`share-button ${copied.success}`}
              onClick={handleCopy}
            >
              {copied !== "" ? <span>{copied.text}</span> : <Share />}
            </div>
          ) : null}
        </div>
        {user?.type === "Provider" ? (
          <div className="price-plan">
            {user?.pricePlan?.level && (
              <h2>{t(formattedPricePlans[user?.pricePlan?.level])}</h2>
            )}
          </div>
        ) : null}
        <ul>
          {user?.type === "Consumer" ? (
            <>
              <li
                onClick={() => {
                  navigate("/sessions");
                  sandwichToggle();
                }}
              >
                <div>
                  <CalendarIcon />
                </div>
                <div>
                  <span>{t("upcomming_sessions")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/invitation");
                  sandwichToggle();
                }}
              >
                <div>
                  <Invitation />
                </div>
                <div>
                  <span> {t("calss_invitations")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/my-classes");
                  sandwichToggle();
                }}
              >
                <div>
                  <GroupIcon />
                </div>
                <div>
                  <span>{t("my_classes")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/history");
                  sandwichToggle();
                }}
              >
                <div>
                  <ClockIcon />
                </div>
                <div>
                  <span>{t("training_history")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/clubs");
                  sandwichToggle();
                }}
              >
                <div>
                  <CellsIcon />
                </div>
                <div>
                  <span>{t("market")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/sent-requests");
                  sandwichToggle();
                }}
              >
                <div>
                  <MarkEmailReadIcon />
                </div>
                <div>
                  <span>{t("sent_requests")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/bills");
                  sandwichToggle();
                }}
              >
                <div>
                  <FinanceIcon />
                </div>
                <div>
                  <span>{t("bills")}</span>
                </div>
              </li>
            </>
          ) : null}

          {user?.type === "Provider" ? (
            <>
              <li
                onClick={() => {
                  navigate("/sessions");
                  sandwichToggle();
                }}
              >
                <div>
                  <CalendarIcon />
                </div>
                <div>
                  <span>{t("upcomming_sessions")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/history/byschedule");
                  sandwichToggle();
                }}
              >
                <div>
                  <ClockIcon />
                </div>
                <div>
                  <span>{t("training_history")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/schedules");
                  sandwichToggle();
                }}
              >
                <div>
                  <GroupIcon />
                </div>
                <div>
                  <span>{t("classes")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/customers");
                  sandwichToggle();
                }}
              >
                <div>
                  <Customers />
                </div>

                <div>
                  <span>{t("customers")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/finances");
                  sandwichToggle();
                }}
              >
                <div>
                  <FinanceIcon />
                </div>
                <div>
                  <span>{t("finance")}</span>
                </div>
              </li>
              <li
                onClick={() => {
                  navigate("/requests");
                  sandwichToggle();
                }}
              >
                <div>
                  <RequestIcon />
                </div>
                <div>
                  <span>{t("requests")}</span>
                </div>
              </li>
            </>
          ) : null}

          <li>
            <div>
              <Setting />
            </div>
            <div
              onClick={() => {
                sandwichToggle();
                navigate("/profile");
              }}
            >
              <span>{t("settings")}</span>
            </div>
          </li>
        </ul>
        <LangSwitcher />
      </div>
      <div className="logout-container">
        {!isPWA && (
          <button className="download" onClick={handleDownloadClick}>
            <DownloadIcon />
            {t("download_app")}
          </button>
        )}
        <button
          className="logout"
          onClick={() => {
            setConfirmModalToggle("modal-confirm");
          }}
        >
          {t("logout")}
        </button>
      </div>
    </div>
  );
};

function areEqual(preValue, postValue) {
  if (preValue.active !== postValue.active) return false;
  return true;
}

export default React.memo(SandwichNavigation, areEqual);
